import { HttpClient, MergeDataCommon } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class CamcFundHero {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.httpClient = new HttpClient();

        this.fund_shareclass_api = FUND_API_SOURCES.FUND_SHARECLASS_SOURCE + this.fundCode;
        this.fund_perf_url = FUND_API_SOURCES.FUND_NAV_SOURCE + this.fundCode;
        this.fund_accumulation_url = FUND_API_SOURCES.FUND_ACCUMULATION_SOURCE + this.fundCode;
    }

    async render() {
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
        };

        const empty_data = { data: {} };
        let perf_data, fund_data, accmulation_data;
        try {
            perf_data = await this.httpClient.get(this.fund_perf_url, options);
        } catch {
            perf_data = empty_data;
        }

        try {
            fund_data = await this.httpClient.get(this.fund_shareclass_api, options);
        } catch {
            fund_data = empty_data;
        }

        try {
            accmulation_data = await this.httpClient.get(this.fund_accumulation_url, options);
        } catch {
            accmulation_data = empty_data;
        }

        const fundHeroData = this.mergeFundHeroData(perf_data, fund_data, accmulation_data);

        this.renderFundHero(fundHeroData);
    }
    mergeFundHeroData(perf_data, fund_data, accmulation_data) {
        let result = {
            nav: MergeDataCommon.formatNumber(perf_data.data?.nav, perf_data.data?.navDecimalPlace),
            priceDate: MergeDataCommon.formatString(perf_data.data?.priceDate, ""),
            changeInPer: MergeDataCommon.formatNumber(perf_data.data?.changeInPer, 2),
            fundType:
                fund_data.data?.fundType?.[1] && fund_data.data.fundType?.[1].fundType
                    ? MergeDataCommon.formatString(fund_data.data.fundType[1].fundType)
                    : "-",
            riskRating: MergeDataCommon.formatString(fund_data.data.riskRating),
            legalName:
                fund_data.data?.fundName?.[1] && fund_data.data.fundName?.[1].legalName
                    ? MergeDataCommon.formatString(fund_data.data.fundName[1].legalName)
                    : "-",
            shortName:
                fund_data.data?.fundName?.[1] && fund_data.data.fundName?.[1].shortName
                    ? MergeDataCommon.formatString(fund_data.data.fundName[1].shortName)
                    : "-",
            accumulatedPrice: MergeDataCommon.formatNumber(
                accmulation_data.data?.accumulatedPrice,
                accmulation_data.data?.accumulatedPriceDecimalPlace,
            ),
            accumulatedPriceDate: MergeDataCommon.formatString(accmulation_data.data?.accumulatedPriceDate, ""),
        };
        return result;
    }

    renderFundHero(fundHeroData) {}

    errorHandler() {}
}

export default CamcFundHero;
